export const paddingS = 8
export const paddingM = 12
export const paddingL = 16

export const halfmarginS = paddingS / 2
export const marginS = paddingS
export const marginM = paddingM
export const marginL = paddingL

export const textBasicSize = 15

export const textDescrSize = 12
export const smallerTextInputSize = 13
export const textTitleSize = 32

//specific to line design
export const defaultInputwidth = 40
export const maxInputwidth = 90
export const defaultSeparator = 1
export const defaultLineHeight = 48
export const defaultCalculItemHeight = 35

export const pickerHeight = 190
export const cornerRadius = 8
export const screenWidth = 600
export const screenHeight = 800
export const hairlineWidth = 1
